import { useCallback, useMemo } from "react"

import { Flex, Modal, Space, Spin, Typography } from "antd"
import { useSelector } from "react-redux"

import DropdownDateBlock from "../../../../Components/Filters/DropdownDateBlock/DropdownDateBlock"
import Private from "../../../../Components/Private"
import { formatCurrency, getCalculatedPeriod } from "../../../../Utils/utils"
import AlertsChart from "../../../BusinessAccountsPage/components/Chart"
import Chart from "./Chart"

const { Text } = Typography

const ChartModal = ({
  open,
  title,
  period,
  setPeriod,
  total,
  data,
  dataType,
  loading,
  close,
  isAlertsChart
}) => {
  const { isMobile } = useSelector((state) => state.nav)

  const totalValueStr = useMemo(() => {
    if (dataType === "volume") return formatCurrency(total / 100)
    return total.toLocaleString()
  }, [data, dataType])

  const handleChangeCustomDate = useCallback((newFilters) => {
    if (newFilters?.["customPeriod"]) {
      setPeriod({
        type: "custom",
        period: newFilters?.customPeriod,
        presetId: newFilters?.__preset_customPeriod ?? null
      })
    } else {
      setTimeout(() => setPeriod("30 days"), 100)
    }
  }, [])

  return (
    <Modal
      classNames={{ content: "clear-bg" }}
      {...(isMobile ? { transitionName: "" } : null)}
      open={open}
      getContainer={() => document.getElementById("main-layout")}
      title={
        <Flex justify={"space-between"} style={{ paddingRight: 48 }}>
          <Flex vertical gap={8}>
            <Text type="secondary">{title}</Text>
            <Text style={{ fontSize: "20px", fontWeight: 600, lineHeight: "28px" }}>
              <Private disabled={dataType !== "volume"}>{totalValueStr}</Private>
            </Text>
          </Flex>

          <Space.Compact size={"large"}>
            {/*<Button*/}
            {/*  className={cls("compact-btn", {*/}
            {/*    active: period === "7 days",*/}
            {/*  })}*/}
            {/*  onClick={() => setPeriod("7 days")}*/}
            {/*>*/}
            {/*  {t("7 days")}*/}
            {/*</Button>*/}
            {/*<Button*/}
            {/*  className={cls("compact-btn", {*/}
            {/*    active: period === "30 days",*/}
            {/*  })}*/}
            {/*  onClick={() => setPeriod("30 days")}*/}
            {/*>*/}
            {/*  {t("30 days")}*/}
            {/*</Button>*/}
            {/*<Button*/}
            {/*  className={cls("compact-btn", { active: period === "all" })}*/}
            {/*  onClick={() => setPeriod("all")}*/}
            {/*>*/}
            {/*  {t("All time")}*/}
            {/*</Button>*/}
            <div>
              <DropdownDateBlock
                id={"customPeriod"}
                customOverlayClassName={"dashboard-filters"}
                label={"Custom"}
                iconType={"calendar_days"}
                dropdownFilters={getCalculatedPeriod(period)}
                presetId={period?.presetId}
                setDropdownFilters={handleChangeCustomDate}
                inactive={period?.type !== "custom"}
              />
            </div>
          </Space.Compact>
        </Flex>
      }
      centered={!isMobile}
      //closeIcon={<Icon type="close_modal"/>}
      footer={null}
      closable="true"
      onCancel={close}
      destroyOnClose
      width={1160}
    >
      <Spin spinning={loading}>
        {isAlertsChart ? (
          <AlertsChart
            height={isMobile ? null : "280px"}
            type={"alerts"}
            loading={loading}
            data={data?.chart}
          />
        ) : (
          <Chart
            height={isMobile ? null : "280px"}
            type={title}
            loading={loading}
            data={data}
            dataType={dataType ?? "count"}
          />
        )}
      </Spin>
    </Modal>
  )
}

export default ChartModal
